import { useUscDispatch, useUscSelector } from "../redux/store";
import { useCheckoutCallback } from "./useSaveTyCode";
import useBackToCarFilterUrl from "./useBackToCarFilterUrl";
import type { UscNavigationParamsType } from "../utils/navUtils";
import { trackCta, UscTrackingLocation } from "../utils/tracking";
import useLocalContactDealerClick from "../../shared-logic/hooks/useLocalContactDealerClick";

/**
 * Returns all necessary params for easily using the navigation and cta utils
 */
const useNavParams = (trackingLocation: UscTrackingLocation): UscNavigationParamsType => {
    const dispatch = useUscDispatch();

    const currentStep = useUscSelector((state) => state.nav.step);
    const context = useUscSelector((state) => state.vehicle.type);
    const vehicle = useUscSelector((state) => state.vehicle.result);
    const activeFinanceOption = useUscSelector((state) => state.basket.activeFinanceOption);
    const userTaxLocationId = useUscSelector((state) => state.externalPrice.userTaxLocationId);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const uscSettings = useUscSelector((state) => state.uscSettings);
    const checkoutType = useUscSelector((state) => state.basket.checkoutType);
    const dealer = useUscSelector((state) => state.dealer.dealer);
    const tyCode = useUscSelector((state) => state.save.data?.code);
    const calculationId = useUscSelector((state) => state.insurance.quote?.calculationId);
    const financeQuoteId = useUscSelector((state) => state.finance.financeQuoteId);
    const configuration = useUscSelector((state) => state.basket.configuration);

    const checkoutCallback = useCheckoutCallback();
    const carFilterUrl = useBackToCarFilterUrl();
    const localContactDealerClick = useLocalContactDealerClick({
        context,
        dealer,
        vehicle,
        detailPageUrl: uscSettings.detailPageUrl,
        localContactDealerFormUrl: uscSettings.localContactDealerFormUrl,
        trackingFn: () => trackCta("vehicle-request", UscTrackingLocation.Pdp, context),
        calculationId,
        financeQuoteId,
        tyCode,
    });

    return {
        dispatch,
        currentStep,
        context,
        vehicle,
        activeFinanceOption,
        userTaxLocationId,
        commonSettings,
        uscSettings,
        checkoutType,
        dealer,
        checkoutCallback,
        carFilterUrl,
        trackingLocation,
        tyCode,
        calculationId,
        financeQuoteId,
        localContactDealerClick,
        configuration,
    };
};

export default useNavParams;
